module.exports = __webpack_public_path__ + "media/images/brands/marque-schwarzkopf-0e9d8d71ae39feca92e38399462585af.jpg";